/*********************************************************
 * Copyright (C) 2015-2018 VMware, Inc. All rights reserved.
 *********************************************************/
/**
 * @fileoverview wmksadapter.js -- wmksAdapter
 * Service to handle wmks session management
 *
 * Currently only support one wmks to use RTAV at the same time
 * and others have to wait the resources get released by that session
 * when it's closed.
 *
 * Should also support RTAV pause when the RTAV-active session
 * is hidden(P2, minor, feature)
 *
 * Call userStopSession can stop working session, but not add
 * for now, current kill switch setting will be applied to new
 * launch session, and one can continue to use the RTAV on the
 * already launched sessions.
 */

import RTAV from './logservice';


let wmksAdapter = (function() {
   let sessionMap = {};
   return {
      /**
       * The function used to add in a wmks session
       * @param {string} sessionId The ID of the session
       * @param {object} session The vvcSession object that passed from wmks
       */
      addSession: function(sessionId, session) {
         if (!RTAV.settings.enabled) {
            RTAV.logService.trace("RTAV has been disabled from being added");
            return;
         }
         if (!sessionId || !session) {
            RTAV.logService.error('can\'t add a invalid session' + sessionId);
            return;
         }
         sessionMap[sessionId] = new RTAV.RtavSession(sessionId, session);
      },

      /**
       * The function used to remove a wmks session, should be call when the corresponding
       * session becomes invalid
       * @param {string} sessionId The ID of the session
       */
      removeSession: function(sessionId) {
         if (!RTAV.settings.enabled) {
            return;
         }
         RTAV.logService.debug("remove session for RTAV:" + sessionId);
         if (!sessionId || !sessionMap[sessionId]) {
            RTAV.logService.debug('can\'t remove a not-exist session' + sessionId);
            return;
         }
         sessionMap[sessionId].stop();
         if (sessionMap.hasOwnProperty(sessionId)) {
            delete sessionMap[sessionId];
         }
      },

      /**
       * The function used to active the rtav session on a valid wmks session, should be
       * called when the corresponding session becomes valid
       * The active means establish rtav sub vvc channel, and finishing the configuring steps,
       * and also tries to process the agent request when device can be obtained.
       * Currently, There can many actived sessions, which means there are many rtav sessions on
       * going, but only one session can send streaming data to the agent since we only allow one
       * to access to the device and encoder to avoid cosuming too much of resources.
       * @param {string} sessionId The ID of the session
       */
      activeSession: function(sessionId) {
         if (!RTAV.settings.enabled) {
            RTAV.logService.trace("RTAV has been disabled from being actived");
            return;
         }
         if (!sessionId || !sessionMap[sessionId]) {
            RTAV.logService.error('can\'t active a not-exist session' + sessionId);
            return;
         }
         sessionMap[sessionId].start();
      },

      userStopSession: function(sessionId) {
         if (!RTAV.settings.enabled) {
            return;
         }
         if (!sessionId || !sessionMap[sessionId]) {
            RTAV.logService.error('can\'t stop a not-exist session' + sessionId);
            return;
         }
         sessionMap[sessionId].userStop();
      },

      isUsingDevices: function(sessionId, type) {
         if (!RTAV.settings.enabled || !sessionId || !sessionMap[sessionId]) {
            return false;
         }
         return sessionMap[sessionId].isUsingDevices(type);
      },

      isAskingPremission: function(sessionId, type) {
         if (!RTAV.settings.enabled || !sessionId || !sessionMap[sessionId]) {
            return false;
         }
         return sessionMap[sessionId].isAskingPremission(type);
      },

      hasSession: function(sessionId) {
         if (sessionMap[sessionId]) {
            return true;
         } else {
            return false;
         }
      }
   };
}());

export default wmksAdapter;